import { useActionState, useEffect } from "react";
import FormBody from "../../../../components/form-body";
import Input from "../../../../components/input";
import Label from "../../../../components/label";
import FormActions from "../../../../components/form-actions";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/button";
import { GoogleCredentialsUpload } from "../actions";
import { GoogleCredentials } from "../../../../models";
import { GoogleSignIn } from "./buttons";

/**
 * Component to upload google credentials file
 */
export default function GoogleCredentialsUploadForm({googleCredentials}:{googleCredentials?:GoogleCredentials}){
    const navigate = useNavigate();
    const [state,formAction,isPending] = useActionState(GoogleCredentialsUpload,null);
    useEffect(()=>{
        if(state?.success)
            navigate("/admin/server-settings?reload=true");
    },[state])
    return <form className="w-full max-w-3xl text-left" action={formAction}>
        <FormBody>
            <div className="">
                <Label>Google Credentials File</Label>
                <Input name="file" type="file" accept=".json"></Input>
                <span>{googleCredentials?"File uploaded":"File not found"}</span>
            </div>
              <FormActions>         
            <Button
                type="submit"
                disabled={isPending}
                className="min-w-[90px]"
                loading={isPending}
            >
                Upload
            </Button>
            <GoogleSignIn visible={googleCredentials !==undefined && googleCredentials.clientId !== undefined}></GoogleSignIn>
           
        </FormActions>
        </FormBody>
      
    </form>
}